import { ReactElement, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";

function SuperUserOnly({ children }: { children: JSX.Element }) : ReactElement | null {
    const { user } = useContext(AuthContext);

    return user && user.isSuperuser ? children : null;
}

export default SuperUserOnly;